/**
 * Intercetta tutti i fetch dell'app portal e aggiunge il Bearer token.
 * Usa chiavi sessionStorage separate da Minerva (portal_token / portal_user)
 * per evitare collisioni se lo stesso browser ha entrambe le app aperte.
 */
export function setupAuthFetch() {
  const originalFetch = window.fetch;

  window.fetch = async (url, options = {}) => {
    const token =
      sessionStorage.getItem("portal_token") ||
      localStorage.getItem("portal_token");

    const isFormData = options.body instanceof FormData;

    const headers = {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    };

    const response = await originalFetch(url, { ...options, headers });

    // Spara token-expired solo se c'era già una sessione attiva,
    // non quando il login stesso fallisce per credenziali errate
    if (response.status === 401) {
      const hasToken =
        sessionStorage.getItem("portal_token") ||
        localStorage.getItem("portal_token");
      if (hasToken) {
        window.dispatchEvent(new CustomEvent("portal-token-expired"));
      }
    }

    return response;
  };
}
